import React, { useEffect, useRef, useState } from 'react';
import { UseFormMethods } from 'react-hook-form';
import ContextMenu, { ContextMenuAction } from 'src/components/common/ContextMenu';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import Owner from 'src/models/tract_detail/Owner';
import WIContractOwnership from 'src/models/tract_detail/WIContractOwnership';
import WIOwnership from 'src/models/tract_detail/WIOwnership';
import AddressUtil from 'src/util/Address';

interface IORRIOwnershipCardProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    ownership: WIOwnership | WIContractOwnership;
    owner: Owner;
    parentIndex: number;
    index: number;
    actions?: Array<ContextMenuAction>;
    prefix?: string;
    onWIInterestChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ORRIOwnershipCard = (props: IORRIOwnershipCardProps) => {
    const popupEl = useRef(null);
    const [contextMenuShowing, setContextMenuShowing] = useState(false);
    const [namePrefix, setNamePrefix] = useState(`leasehold.leaseholdOwnerships[${props.parentIndex}].orriOwnerships`);

    useEffect(() => {
        if (popupEl.current) {
            TweenLite.to(popupEl.current, 0, { height: '2rem', width: '1.7rem', opacity: '0', pointerEvents: 'none' });
        }
    }, [popupEl]);

    useEffect(() => {
        if (!!props.prefix) {
            setNamePrefix(props.prefix);
        }
    }, [props.prefix]);

    return (
        <div
            key={props.ownership.id}
            className="orri"
            onMouseEnter={() => setContextMenuShowing(true)}
            onMouseLeave={() => setContextMenuShowing(false)}
        >
            <div style={{ position: 'absolute', right: '-8px', top: '-2px' }}>
                <ContextMenu actions={props.actions} isVisible={contextMenuShowing} />
            </div>
            <div className="name">
                <div>{props.owner.name}</div>
                <div>{AddressUtil.concatWithCommas(props.owner.addressLine1, props.owner.city, props.owner.state)}</div>
            </div>

            <div>
                <div style={{ height: '1px' }}>
                    <input type="hidden" name={`${namePrefix}[${props.index}].id`} ref={props.register()} />
                    <RHFInputBox
                        label=""
                        name={`${namePrefix}[${props.index}].parentOwnershipId`}
                        type="hidden"
                        register={props.register}
                        errors={props.errors}
                    />
                    <RHFInputBox
                        label=""
                        name={`${namePrefix}[${props.index}].ownershipId`}
                        type="hidden"
                        register={props.register}
                        errors={props.errors}
                    />
                    <RHFInputBox
                        label=""
                        name={`${namePrefix}[${props.index}].projectId`}
                        type="hidden"
                        register={props.register}
                        errors={props.errors}
                    />
                </div>

                <div style={{ marginRight: '15.7rem' }}>
                    <RHFInputBox
                        label="ORRI Interest"
                        name={`${namePrefix}[${props.index}].decimalInterest`}
                        register={props.register}
                        type="text"
                        errors={props.errors}
                        onChange={props.onWIInterestChange}
                    />
                </div>
            </div>
        </div>
    );
};

export default ORRIOwnershipCard;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ORRIOwnershipCard.redesign.tsx